export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./description.vue?vue&type=template&id=22109310"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/description.vue?vue&type=template&id=22109310
// module id = adrK
// module chunks = 0